// extracted by mini-css-extract-plugin
export default {"container":"s01_container__6hzcS","title":"s01_title__QtM7b"};